import { useRef } from "react";

/** Drag the handle; scrolling inside the sheet remains native and independent. */
export function SheetHandle({ level, onChange, onDrag, label = "חלונית החיפוש" }: {
  level: number;
  onChange: (level: number) => void;
  onDrag?: (distance: number | null) => void;
  label?: string;
}) {
  const start = useRef<{ id: number; y: number } | null>(null);
  const dragged = useRef(false);
  const move = (direction: number) => onChange(Math.max(0, Math.min(2, level + direction)));
  return <button className="sheet-toggle" aria-label={`${label} — ${["קטנה", "בינונית", "מלאה"][level]}. גררו או השתמשו בחצים לשינוי הגודל`}
    aria-expanded={level > 0}
    onPointerDown={event => {
      if (!event.isPrimary || event.button !== 0) return;
      start.current = { id: event.pointerId, y: event.clientY };
      dragged.current = false;
      event.currentTarget.setPointerCapture(event.pointerId);
    }}
    onPointerMove={event => {
      if (start.current?.id !== event.pointerId) return;
      const delta = event.clientY - start.current.y;
      if (Math.abs(delta) > 8) dragged.current = true;
      if (dragged.current) onDrag?.(delta);
    }}
    onPointerUp={event => {
      if (start.current?.id !== event.pointerId) return;
      const delta = event.clientY - start.current.y;
      start.current = null;
      onDrag?.(null);
      if (Math.abs(delta) >= 36) { dragged.current = true; move(delta < 0 ? 1 : -1); }
    }}
    onPointerCancel={() => { start.current = null; dragged.current = true; onDrag?.(null); }}
    onLostPointerCapture={() => { start.current = null; onDrag?.(null); }}
    onClick={() => { if (!dragged.current) onChange(level === 0 ? 1 : 0); dragged.current = false; }}
    onKeyDown={event => {
      if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return;
      event.preventDefault(); move(event.key === "ArrowUp" ? 1 : -1);
    }}>
    <span className="sheet-grip" aria-hidden="true" />
    <span>{level === 0 ? "לאן נוסעים?" : "גררו למטה להצגת המפה"}</span>
  </button>;
}
